import { useCart } from "../context/CartContext";
import AlertModal from "./AlertModal";

export default function GlobalAlert() {
  const { alert, setAlert } = useCart();

  return (
    <AlertModal
      isOpen={alert.open}
      onClose={() => setAlert({ open: false, message: "", type: "info" })}
      message={alert.message}
      type={alert.type}
    />
  );
}
